import DateRangePicker from './DateRangePicker';
export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/DateRangePicker/index.js